export default "__VITE_ASSET__B1guSf5c__"